import { render, staticRenderFns } from "./UnderlineButton.vue?vue&type=template&id=63111a3a&"
import script from "./UnderlineButton.vue?vue&type=script&lang=js&"
export * from "./UnderlineButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports